import React, { useMemo } from 'react';
import { min } from 'lodash/fp';

import { PieChart, PieChartAnalyticsData, GraphKeyAndColour } from '../../../shared/analytics/PieChart';
import styles from '../PortfolioAnalytics.module.scss';
import { Icon } from '../../../shared/icon/Icon';
import { Document } from '../../../shared/icons';

interface PortfolioAnalyticsPieChartWrapperProps {
    chartHeight: number;
    chartWidth: number;
    data: PieChartAnalyticsData[];
    onHover: (data: PieChartAnalyticsData | null, id: string) => void;
    extractKeyColours?: (GraphKeyAndColour: GraphKeyAndColour) => void;
}

export const PortfolioAnalyticsPieChartWrapper: React.FC<PortfolioAnalyticsPieChartWrapperProps> = ({ chartHeight, chartWidth, data, onHover, extractKeyColours }) => {
    const diameter = useMemo(() => min([chartHeight, chartWidth])!, [chartHeight, chartWidth]);

    return (
        <div className={styles.chartWrapper} style={{ height: `${chartHeight}px`, width: `${chartWidth}px` }}>
            <PieChart data={data} diameter={diameter} onHover={onHover} extractPieColours={extractKeyColours} id='portfolio-analytics-pie-chart' />
            <div
                className={styles.pieChartIcon}
                style={{ height: `${diameter / 3}px`, width: `${diameter / 3}px` }}
            >
                <Icon icon={Document} fontSize={diameter / 5} />
            </div>
        </div>
    );
};
